var _defs, _line, _line2, _path, _polygon, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.21,
    y1: 171.07,
    x2: 171.79,
    y2: 171.07
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.21,
    y1: 203.36,
    x2: 171.79,
    y2: 203.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.27,18H102L45.5,67.9V222.77A15.27,15.27,0,0,0,60.73,238H195.27a15.27,15.27,0,0,0,15.23-15.23V33.23A15.27,15.27,0,0,0,195.27,18Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.01 18 101.77 67.82 45.5 67.9 102.01 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.11,74.67V48.13a6,6,0,1,1,12.09,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.2,81.15V41.5a6,6,0,1,1,12.08,0V81.15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.28,48.22a6.05,6.05,0,1,1,12.1,0v13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148,116.31c0-12.13-15.09-18.5-15.09-18.5l0,0V81.65a11.44,11.44,0,0,0-4.25-8.45l-2.39-1.65c-2.48-1.56-6-.23-6,2.75v37.27a29.26,29.26,0,0,0,23.63,28.62l11.62.09a29.22,29.22,0,0,0,24-28.71V60.24a6,6,0,1,0-12.09,0v25"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEea);
export default __webpack_public_path__ + "static/media/eea.e82089428ee2dc3830ac8a373d473e62.svg";
export { ForwardRef as ReactComponent };